import { UPLOAD_ZONE_MAPPING_FAILURE, UPLOAD_ZONE_MAPPING_REQUEST, UPLOAD_ZONE_MAPPING_REST, UPLOAD_ZONE_MAPPING_SUCCESS, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const uploadZoneMappingReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_ZONE_MAPPING_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case UPLOAD_ZONE_MAPPING_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case UPLOAD_ZONE_MAPPING_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case UPLOAD_ZONE_MAPPING_REST:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default uploadZoneMappingReducer;
